import type { PageOriginContext } from "@/lib/page-origin-context";

/**
 * Best-effort origin for game links when no `SearchListingProvider` is mounted
 * (e.g. blog, login). Topic vs game under `/games/[slug]` cannot be distinguished by path alone.
 */
export function inferPageOriginFromPathname(pathname: string | null): PageOriginContext | null {
  if (!pathname) return null;
  if (pathname === "/" || pathname === "/games") {
    return { section: "games", slug: null };
  }
  return null;
}
